module.exports = __webpack_public_path__ + "img/ximenzi.1596ed24.png";